import { Currency } from "../../models/RestModels";

export function getEmptyCurrency(): Currency
{
		return {
			name: '',
			id: ''
		};
}
